import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['container', 'errorText', 'totalComments', 'contentInput',
                    'confirmationContainer', 'confirmationMessage',
                    'emailInput', 'form', 'nameInput']

  // Action used after a Rails remote form is submitted successfully
  onCommentSuccess(event) {
    let [data, status, xhr] = event.detail;
    // Hide the form
    if (data.success) {
      if (data.html) {
        this.containerTarget.insertAdjacentHTML('beforeend', data.html)
      }
      if (data.count) {
        this.totalCommentsTarget.innerText = `${data.count} comments`
      }
      if (data.message && this.hasConfirmationContainerTarget && this.hasConfirmationMessageTarget) {
        // Display the confirmation message
        this.confirmationMessageTarget.innerText = data.message
        this.confirmationContainerTarget.classList.add('visible')
        // Hide the form
        this.formTarget.classList.add('d-none')

        // Notify other controllers about this
        this.fireEvent('comment-created')
      }
      // Reset the comment's input text
      this.contentInputTarget.value = null
    } else {
      this.showError(data.message)
    }
  }

  fireEvent(eventName) {
    const event = new CustomEvent(eventName)
    window.dispatchEvent(event)
  }

  onCommentError(event) {
    let [data, status, xhr] = event.detail;
    this.showError('An unexpected error occurred. Please, try again later.')
  }

  showError(message) {
    this.errorTextTarget.innerText = message
    this.errorTextTarget.classList.remove('d-none')
  }
}